import { OperatorPortalOverviewPage } from "@/components/non_registrant/operator-portal-pages";
import { createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/operator/overview")({
  component: OperatorPortalOverviewPage,
});
